/**
 * Create a cleaned version of a string to be used as an id or class name.
 */
export function textToClassName(str: string) {
  return str
    .toLowerCase()
    .trim()
    .replace(/\W/g, '-')
    .replace(/^(\d+)/, '-$1')
}
